import styled from 'styled-components'

const MyDiv = styled.div`
.page_heading {
    margin-bottom: 24px;
}

.btn {
    background:rgba(0, 104, 56, 1);
    color:white;
    &:hover{
    background:rgba(0, 104, 56, 1);
    color:white;
  }
}

.flex_header {
    align-items: center;
    justify-content: space-between;
}

.table_header {
    background-color: #f9fafb !important;
}

.edit:hover {
   text-decoration: underline;
}

.btn-green {
  background: green;
  color: white;
  &:hover {
    background: darkgreen;
  }
}

.btn-red {
  background: red;
  color: white;
  &:hover {
    background: darkred;
  }
} 
`
export default MyDiv
